import { render, staticRenderFns } from "./DropdownRadio.vue?vue&type=template&id=49a6ca80"
import script from "./DropdownRadio.vue?vue&type=script&lang=js"
export * from "./DropdownRadio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports